const ClassificacaoCliente = {
    BLACK : 'BLACK',
    OURO : 'OURO',
    PRATA : 'PRATA',
    BRONZE : 'BRONZE'
}

export default ClassificacaoCliente;